module.exports = __webpack_public_path__ + "static/usopen-03-6d65c33b2708d7413726ca8b5981a47d.png";